import { useCancelRequest, useGetRequest } from "../../../api/query_hooks/request";
import ConfirmationModal from "../../../components/dialog/ConfirmationModal";
import Thumbnail from "../../../components/images/thumbnail/Thumbnail";
import { getArtworkImageUrl } from "../../../api/endpoints";
import ReceivedOffersPanel from "./ReceivedOffersPanel";
import { Link, useLocation } from "react-router-dom";
import { Button, Spinner } from "react-bootstrap";
import { useState } from "react";

const RequestDetails = ({id}) => {

    const requestsQuery = useGetRequest(parseInt(id));
    

    return (
        <>
            {requestsQuery.isLoading &&
                <div className='bg-dark flex-center gap-2 col-7 h-100 rounded-bottom m-auto'>
                    <Spinner animation="border" role="status" aria-describedby="loading" />
                </div>
            }
            {requestsQuery.isError &&
                <div className='bg-dark flex-center gap-2 col-7 h-100 rounded-bottom m-auto'>
                    {requestsQuery.error.response?.data}
                </div>
            }
            { requestsQuery.isSuccess &&
                <div className='bg-dark d-flex flex-column gap-2 col-7 rounded-bottom'>

                    <RequestStatusBar id="request-status-bar" request={requestsQuery.data?.data} />

                    <RequestProgressBar id="request-progress-bar" request={requestsQuery.data?.data} />

                    <RequestInfoPanel id="request-info-panel" request={requestsQuery.data?.data} />

                    <ReceivedOffersPanel id="offer-panel" requestId={id} offers={requestsQuery.data?.data.offers} />

                </div>
            }
        </>
    );
};

const RequestStatusBar = ({id="", request}) => {

    const cancelRequestMutation = useCancelRequest();

    const [show, setShow] = useState(false);

    const handleDelete = () => {
        cancelRequestMutation.mutate(request?.id);
        setShow(false);
    }


    return (
        <div id={id} className="text-small flex-between px-3 py-1 border-bottom">
            <ConfirmationModal variant="danger" show={show} setShow={setShow} onConfirm={handleDelete} message="Are you sure you want to cancel this request?" />

            <div className='d-flex flex-column'>
                <p className='m-0 text-mini user-select-none'>Request ID:</p>
                <p className='m-0'><>&#8226;&nbsp;</> {request?.id}</p>
            </div>
            <div className='d-flex flex-column'>
                <p className='m-0 text-mini user-select-none'>Created on:</p>
                <p className='m-0'>{new Date(request?.createdAt).toLocaleDateString()}</p>
            </div>
            <Button
                variant={request?.status === 'PENDING' ? 'danger' : 'dark'}
                type='button'
                onClick={() => setShow(true)}
                disabled={request?.status !== 'PENDING'}
                className={"py-1 "+(request?.status !== 'PENDING' && 'border border-secondary')}
            >
                Cancel request
            </Button>

        </div>
    );
};

const RequestProgressBar = ({id="", request}) => {

    return (
        <div id={id} className='bg-darker text-mini d-flex mx-3 mt-1 py-1 rounded border border-2 border-black'>
            <p className='ps-3 col-4 m-0 border-right'>
                Requested: {new Date(request?.createdAt).toLocaleDateString()}
            </p>
            <p className={'ps-3 col-4 m-0 border-right '+(
                request?.status === 'CONFIRMED' || request?.status === 'COMPLETED' ? 'text-light' : 'text-white-50'
            )}>
                Confirmed: {request?.status === 'CONFIRMED' ? (new Date(request?.updatedAt).toLocaleDateString()) : ''}
            </p>
            <p className={'ps-3 col-4 m-0 '+(
                (request?.status === 'CANCELED' || request?.status ==='DECLINED' || request?.status === 'COMPLETED') ? 'text-light' : 'text-white-50'
            )}>
                {request?.status === 'CANCELED' && "Canceled: "+(new Date(request?.updatedAt).toLocaleDateString())}
                {request?.status === 'DECLINED' && "Declined: "+(new Date(request?.updatedAt).toLocaleDateString())}
                {request?.status !== 'CANCELED' && request?.status !== 'DECLINED' &&
                    "Completed: "+(request?.status === 'COMPLETED' ? (new Date(request?.updatedAt).toLocaleDateString()) : '')
                }
            </p>
        </div>
    );
};

const RequestInfoPanel = ({id="", request}) => {

    const location = useLocation();


    return (
        <div id={id} className="d-flex px-3 gap-2">
            <Link
                to={"/artworks/"+request?.artwork.code}
                state={{back: location.pathname}}
                className="bg-darker hov-bg-1 d-flex col-6 h-100 gap-5 p-2 border border-2 border-black rounded"
            >
                <Thumbnail
                    src={request?.artwork.images?.length ? getArtworkImageUrl(request?.artwork.images[0].path) : process.env.PUBLIC_URL+"/default_artwork.png"}
                    alt={request?.artwork.title}
                    className='col-6'
                />
                <div className='d-flex flex-column gap-2'>
                    <p className='m-0'>{request?.artwork.code}</p>
                    <p className='m-0'>{request?.artwork.title}</p>
                    <p className='m-0'>{request?.artwork.author}</p>
                </div>
            </Link>

            <div className="bg-darker d-flex flex-column flex-grow-1 h-100 border border-2 border-black rounded overflow-y-auto">
                <div className="hov-bg-1 flex-between col-12 px-4 py-2 border-bottom border-2 border-black">
                    <div className="flex-center flex-column align-items-start">
                        {request?.toUser ? 
                            <>
                                <p className='text-end m-0'>{request?.toUser.username}</p>
                                <p className='text-end m-0'>{request?.toUser.email}</p>
                            </>
                        :
                            <p className='text-start m-0'>The request hasn't been accepted by an expert yet</p>
                        }
                    </div>
                    {request?.toUser &&
                        <Thumbnail
                            src={request?.toUser.propic ? getArtworkImageUrl(request?.toUser.propic) : process.env.PUBLIC_URL+"/default_propic.png"}
                            className='w-20'
                            roundedCircle={true}
                        />
                    }
                </div>
                <div className="hov-bg-1 flex-between flex-grow-1 col-12 px-4 py-2">
                    <div className="d-flex flex-column gap-1">
                        <p className='m-0'>Certificate type:</p>
                        <p className='m-0'>Request status:</p>
                        {request?.offerId && <p className='m-0'>Price:</p>}
                    </div>
                    <div className="d-flex flex-column align-items-end gap-1">
                        <p className='m-0'>{request?.type ? "Evaluation" : "Expertise"}</p>
                        <p className='m-0'>{request?.status}</p>
                        {request?.offerId && <p className='m-0'>{request?.price} €</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};


export default RequestDetails;